import { render, staticRenderFns } from "./ReSendQueueModal.vue?vue&type=template&id=153c4a1e&scoped=true"
import script from "./ReSendQueueModal.vue?vue&type=script&lang=js"
export * from "./ReSendQueueModal.vue?vue&type=script&lang=js"
import style0 from "./ReSendQueueModal.vue?vue&type=style&index=0&id=153c4a1e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "153c4a1e",
  null
  
)

export default component.exports